import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Button,
  Input,
  TextField,
} from "@mui/material";

import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import {
  saveRecruitmentRequest,
} from "../../../store/recruitment/actions";

import { isEmpty } from "lodash";
import moment from "moment";
import { showError } from "../../toastify";
import {
  containsKeyInReplacements,
  replaceTextPlaceholders,
} from "../../common/components/Utils";
import AdvertSkeleton from "../../common/components/AdvertSkeleton";
import CustomizedLetter from "../../documents/LetterFormat/CustomizedLetter";
import { ReactMultiEmail } from "react-multi-email";
import TextEditorComponent from "../../common/components/TextEditorComponent";
import InstitutionDetails from "../../training/components/InstitutionDetails";
import axios from "axios";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { buildAdministrationLetterCustomization } from "../utils/administrationLetterUtils";

const maxCharCount = 1500;
const PLACEHOLDER_PATTERN = /<<<\s*[^<>]+\s*>>>/g;

const NewRecruitmentRequestDialog = (props) => {
  const {
    loading,
    onWait,
    showRequestForm,
    setShowRequestForm,
    selectedApplication,
    saveRecruitmentRequest,
    user,
    isFromWaitingList,
    initiateLetterCustomization,
    letterNo,
    requestTypes,
    recruitmentRequests,
  } = props;
  console.log(initiateLetterCustomization);
  console.log("requestTypes", requestTypes);
  console.log("selectedApplication", selectedApplication);
  console.log("letterNo", letterNo);

  const [recruitmentRequestType, setRecruitmentRequestType] = useState(null);
  const [letterFooterContent, setLetterFooterContent] = useState(null);
  const [applicationRequestApprover, setApplicationRequestApprover] =
    useState(null);

  const [showConfirmSubmissionDialog, setShowConfirmSubmissionDialog] =
    useState(false);
  const [ccEmails, setCCEmails] = useState([]);
  const [localStorageKey, setLocalStorageKey] = useState({
    letter: `${selectedApplication?.applicantId}-draftContent`,
    cc: `${selectedApplication?.applicantId}-copiedInstitution`,
  });
  const [replacements, setReplacements] = useState({
    positionName: "",
    effectiveDate: "",
    provisionalAppointmentReference: "",
    reportReference: "",
    appointmentReferenceNo: "",
    appointmentReferenceDate: "",
  });

  const [letterCustomization, setLetterCustomization] = useState(
    initiateLetterCustomization || null
  );

  useEffect(() => {
    if (
      recruitmentRequests &&
      initiateLetterCustomization?.requestTypeId &&
      selectedApplication
    ) {
      const customization = buildAdministrationLetterCustomization(
        selectedApplication,
        +initiateLetterCustomization.requestTypeId,
        recruitmentRequests
      );
      setLetterCustomization(customization);
    }
  }, [recruitmentRequests, initiateLetterCustomization, selectedApplication]);
  const [formData, setFormData] = useState({
    userId: selectedApplication.userId,
    selectedApplicationId: selectedApplication.applicantId,
    applicationId: selectedApplication.applicantId,
    requestTypeId:
      recruitmentRequestType?.id || initiateLetterCustomization?.requestTypeId,
    title: recruitmentRequestType?.subject || recruitmentRequestType?.name || "",
    reason: recruitmentRequestType?.subject || recruitmentRequestType?.name || "",
    effectiveOn: letterCustomization?.effectiveDate,
    docLetterNo: letterNo,
    cc: null,
    letterBodyContent: "",
    copiedInstitutionContent: "",

    employeeId: selectedApplication.userId,
  });
console.log('letterCustomization', letterCustomization);
  // useEffect(() => {
  //   getApprover(selectedApplication.applicantId);
  // }, []);


  useEffect(() => {
    setRecruitmentRequestType(recruitmentRequestTypeGroupDropdown());
  }, [requestTypes]);

  useEffect(() => {
    if (!recruitmentRequestType) return;

    const template = recruitmentRequestType?.letterBodyContent || "";
    if (!template) return;
    
    const letterBodyContent = replacePlaceholders(
      template,
      false,
      formData.effectiveOn
    );
    console.log('letterBodyContent', letterBodyContent);
    setFormData((prevForm) => ({
      ...prevForm,
      letterBodyContent,
    }));
  }, [recruitmentRequestType, formData.effectiveOn]);

  useEffect(() => {
    if (recruitmentRequestType) {
      const title =recruitmentRequestType?.subject || recruitmentRequestType?.name || "";
      const reason = recruitmentRequestType?.subject || recruitmentRequestType?.name || "";
      setFormData({
        ...formData, // Spread the existing formData object
        title: title, // Update title property
        reason: reason, // Update reason property
      });
    }
  }, [recruitmentRequestType]);

  const recruitmentRequestTypeGroupDropdown = () => {
    return requestTypes.find(
      (recruitmentRequestType) =>
        recruitmentRequestType?.id ===
        +initiateLetterCustomization?.requestTypeId
    );
  };

  const onClose = () => {
    setShowRequestForm(false);
    setFormData({
      userId: "",
      selectedApplicationId: "",
      requestTypeId: "",
      reason: "",
      effectiveOn: "",
      docLetterNo: "",
      cc: [],
      files: [],
    });
  };

  const onSave = () => {
    if (!letterFooterContent?.entity?.acronym) {
      showError(`The institution acronym is missing!`);
      return false;
    }

    if (
      !!letterFooterContent &&
      !letterFooterContent?.entity?.institutionPhone
    ) {
      showError(`The institution phone number is required. Please update it`);
      return false;
    }

    if (
      letterFooterContent?.entity?.institutionPhone.includes("+25078XXXXXXX")
    ) {
      showError(
        `The institution phone number (${
          letterFooterContent?.entity?.institutionPhone || ""
        }) does not seem correct. Please update it.`
      );
      return false;
    }

    if (
      !!letterFooterContent &&
      !letterFooterContent?.entity?.institutionEmail
    ) {
      showError(`The institution email is required. Please update it`);
      return false;
    }

    if (letterFooterContent?.entity?.institutionEmail.includes("example")) {
      showError(
        `The institution email (${
          letterFooterContent?.entity?.institutionEmail || ""
        }) does not seem correct. Please update it.`
      );
      return false;
    }

    if (!!letterFooterContent && !letterFooterContent?.entity?.poBox) {
      showError(`The institution PO.Box is required. Please update it`);
      return false;
    }

    if (!!letterFooterContent && !letterFooterContent?.entity?.websiteUrl) {
      showError(`The institution website url is required. Please update it`);
      return false;
    }
    if (!!letterFooterContent && !letterFooterContent?.entity?.twitterPage) {
      showError(
        `The institution former(twitter) is required. Please update it`
      );
      return false;
    }
    //letterFooterContent

    const letterBodyContent = formData.letterBodyContent;

    const copiedInstitutionContent =
      formData.copiedInstitutionContent;

    if (!letterBodyContent) {
      showError(`The letter content is required`);
      return false;
    }

    if (replacePlaceholders(letterBodyContent, true)) {
      showError(`Please update a letter template`);
      return false;
    }

    const placeholders = letterBodyContent.match(PLACEHOLDER_PATTERN) || [];
    if (placeholders.length > 0) {
      showError(
        `Please replace all placeholder values marked with <<< >>> before submitting.`
      );
      return false;
    }
    // Regular expression to match one or more occurrences of <div><br /></div>
    const regex = new RegExp('(<div><br></div>)+');

    if (!!regex.test(copiedInstitutionContent) && !!ccEmails.length) {
      showError(
        `You've added the CC emails, but you didn't include the copied institution content.`
      );
      return false;
    }
    formData.letterBodyContent = letterBodyContent;
    formData.copiedInstitutionContent = copiedInstitutionContent;
    formData.cc = JSON.stringify(ccEmails);
// console.log(formData);
    saveRecruitmentRequest(formData, onClose);
  };


  const replacePlaceholders = (
    template,
    isVerifyContainsKeyInReplacement = false,
    effectiveDateOverride = null
  ) => {
    const effectiveOn = effectiveDateOverride || formData.effectiveOn;
    const replacement = {
      ...replacements,
      entityName: selectedApplication?.entityName || "",
      positionName: selectedApplication?.positionName || "",
      effectiveDate: effectiveOn ? moment(effectiveOn).format("LL") : "",
    };
    if (+letterCustomization?.requestTypeId === 2) {
      replacement.provisionalAppointmentReference =
        letterCustomization?.provisionalAppointmentReference;
      replacement.reportReference =
        letterCustomization?.reportReference;
    }
    if (+letterCustomization?.requestTypeId === 3) {
      replacement.appointmentReferenceNo =
        letterCustomization?.appointmentReferenceNo;
      replacement.appointmentReferenceDate =
        letterCustomization?.appointmentReferenceDate;
    }
    setReplacements(replacement);
    if (!!isVerifyContainsKeyInReplacement)
      return containsKeyInReplacements(template, replacement);
    return replaceTextPlaceholders(template, replacement);
  };

  const onReplaceLetterPlaceholder = (date) => {
    const template = recruitmentRequestType?.letterBodyContent || "";
    const updatedContent = replacePlaceholders(
      template,
      false,
      date || formData.effectiveOn
    );

    setFormData((prevForm) => ({
      ...prevForm,
      effectiveOn: date || prevForm.effectiveOn,
      letterBodyContent: updatedContent,
    }));
  };

  const getEditorContent = (data) => {
    setFormData((prevForm) => ({
      ...prevForm,
      letterBodyContent: data.contents,
    }));
  };
  const getEditorContent3 = (data) => {
    setFormData((prevForm) => ({
      ...prevForm,
      copiedInstitutionContent: data.contents,
    }));
  };
  const handleLoadFooterContent = (data) => {
    // console.log(data);
    setLetterFooterContent(data);
  };
  console.log('letterBodyContent', formData?.letterBodyContent || "");
  return (
    <>
      <Dialog
        // onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showRequestForm}
        fullWidth={true}
        maxWidth={"md"}
      >
        <DialogTitle className="text-primary">
          <Typography
            variant="overline"
            className="text-truncate"
            display="block"
            style={{ maxWidth: "70%" }}
          >
            <div className="headerorg mb-0">
              <div className="header_cont">
                {selectedApplication.positionName && (
                  <div className="header_cont">
                    <span className="ml-0">
                      <span className="ml-0 text-success">
                        {recruitmentRequestType?.name}
                      </span>{" "}
                      -{" "}
                      {!!isFromWaitingList
                        ? selectedApplication.requestedPositionName
                        : selectedApplication.positionName}
                    </span>{" "}
                  </div>
                )}
                /
                <span className="ml-2 text-dark">
                  {selectedApplication?.lastName}{" "}
                  {selectedApplication?.firstName}
                </span>
              </div>
            </div>
          </Typography>

          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ width: "100%", minHeight: "95vh" }} className="mt-1">
            <div className="py-3">
              {isEmpty(recruitmentRequestType) && <AdvertSkeleton />}
              {!isEmpty(recruitmentRequestType) && !isEmpty(selectedApplication) && !isEmpty(letterNo) && (
                  <>
                    {" "}
                    <div className="row">
                      <div className="col-6  pl-2 mt-1">
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <DesktopDatePicker
                            label="Effective Date"
                            inputFormat="MM/dd/yyyy"
                            minDate={
                              +recruitmentRequestType?.effectiveInDays > 0
                                ? moment().subtract(
                                    recruitmentRequestType?.effectiveInDays,
                                    "days"
                                  )
                                : moment(
                                    user?.currentDate || new Date()
                                  ).subtract(30, "days")
                            }
                            maxDate={
                              +recruitmentRequestType?.effectiveInDays > 0
                                ? moment().add(
                                    recruitmentRequestType?.effectiveInDays,
                                    "days"
                                  )
                                : moment(user?.currentDate || new Date()).add(
                                    60,
                                    "days"
                                  )
                            }
                            value={formData.effectiveOn}
                            onChange={(date) => {
                              // console.log(date);
                              setFormData({
                                ...formData,
                                effectiveOn: date,
                              });
                              onReplaceLetterPlaceholder(date);
                            }}
                            renderInput={(params) => (
                              <TextField
                                onKeyDown={(e) => e.preventDefault()}
                                required={true}
                                fullWidth
                                size="small"
                                {...params}
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>
                    <div className="mx-2 w-full">
                      <CustomizedLetter
                     
                        disableToEditLetterHeader={true}
                        enableToFillLetter={true}
                        ccSelectForm={
                          <>
                            <strong>Enter CC Institution Email</strong>
                            <ReactMultiEmail
                              placeholder="Enter CC Institution Email"
                              emails={ccEmails}
                              onChange={(_emails) => {
                                setCCEmails(_emails);
                              }}
                              getLabel={(email, index, removeEmail) => {
                                return (
                                  <div data-tag key={index}>
                                    {email}
                                    <span
                                      data-tag-handle
                                      onClick={() => removeEmail(index)}
                                    >
                                      ×
                                    </span>
                                  </div>
                                );
                              }}
                            />
                          </>
                        }
                        ccEmails={ccEmails}
                        docLetterNo={letterNo[0]?.id || ""}
                        signContent={
                          <>
                            <InstitutionDetails
                              headOfInstitution={{
                                isDelegated:
                                  applicationRequestApprover?.isDelegated ||
                                  false,
                                isMinster:
                                  applicationRequestApprover?.isMinster ||
                                  false,
                                firstName:
                                  applicationRequestApprover?.ministryApproverFirstName,
                                lastName:
                                  applicationRequestApprover?.ministryApproverLastName,
                                institutionName:
                                  applicationRequestApprover?.ministryApproverInstitutionName,
                                positionName:
                                  applicationRequestApprover?.ministryApproverPositionName,
                                institutionName:
                                  applicationRequestApprover?.ministryApproverInstitutionName ||
                                  "",
                                canAddInstitutionName:
                                  applicationRequestApprover?.ministryApproverCanAddInstitutionName ||
                                  false,
                              }}
                              userSignature={null}
                            />
                          </>
                        }
                        subTitle={
                          "Dear " +
                          (selectedApplication.lastName.toUpperCase() +
                            " " +
                            selectedApplication.firstName)
                        }
                        recipientContent={
                          <>
                            {selectedApplication.lastName.toUpperCase() +
                              " " +
                              selectedApplication.firstName}{" "}
                            <br />
                            Tel: {selectedApplication.phoneNumber} <br />
                            Email: {selectedApplication.email} <br />
                          </>
                        }
                        entitySectorId={
                          applicationRequestApprover?.appointingAuthEntitySectorId ||
                          applicationRequestApprover?.approverEntitySectorId ||
                          null
                        }
                        planningEntityId={
                          applicationRequestApprover?.appointingAuthPlanningEntityId ||
                          applicationRequestApprover?.approverPlanningEntityId ||
                          null
                        }
                        letterBodyContentInput={
                          <>
                            <TextEditorComponent
                              id="editor-recruitment-textarea"
                              options={{
                                autoSave: false,
                                localStorageKey: localStorageKey.letter,
                                maxCharCount: maxCharCount,
                                defaultValue: formData.letterBodyContent
                              }}
                              onEditorChange={(data) => {
                                getEditorContent(data);
                              }}
                            />
                          </>
                        }
                        letterBodyContent={formData?.letterBodyContent || ""}
                        title={recruitmentRequestType?.subject || ""}
                        copiedInstitutionContentInput={
                          <>
                            <br />
                            <strong>Enter CC Institution Name</strong>
                            <TextEditorComponent
                              id="editor-recruitment-textarea2"
                              options={{
                                autoSave: false,
                                height: "200px",
                                localStorageKey: localStorageKey.cc,
                                maxCharCount: maxCharCount,
                                defaultValue: !!window.localStorage.getItem(
                                  localStorageKey.cc
                                )
                                  ? window.localStorage.getItem(
                                      localStorageKey.cc
                                    )
                                  : formData.copiedInstitutionContent,
                              }}
                              onEditorChange={(data) => {
                                getEditorContent3(data);
                              }}
                            />
                          </>
                        }
                        copiedInstitutionContent={
                          formData?.copiedInstitutionContent || ""
                        }
                        loadFooterContent={(data) =>
                          handleLoadFooterContent(data)
                        }
                      />
                    </div>
                  </>
                )}
            </div>
          </Box>
        </DialogContent>
        {!isEmpty(recruitmentRequestType) && !onWait && (
          <DialogActions className="d-flex justify-content-center pb-3">
            <Button
              color="success"
              variant="contained"
              disabled={
                loading ||
                onWait ||
                isEmpty(recruitmentRequestType) ||
                !applicationRequestApprover
              }
              onClick={() => setShowConfirmSubmissionDialog(true)}
              size="md"
            >
              {onWait ? "Wait.." : <>Submit</>}
            </Button>
          </DialogActions>
        )}
      </Dialog>
      {showConfirmSubmissionDialog && (
        <ConfirmationDialog
          confirmationDialog={showConfirmSubmissionDialog}
          message={`Are you sure you want to Submit the ${
            recruitmentRequestType?.name
          } for ${
            selectedApplication?.lastName + " " + selectedApplication?.firstName
          }?`}
          setConfirmationDialog={setShowConfirmSubmissionDialog}
          onYes={() => {
            onSave();
          }}
        />
      )}
    </>
  );
};

const mapStateToProps = ({
  loading,
  onWait,
  user,
}) => {
  return {
    loading,
    onWait,
    user,
  };
};
export default connect(mapStateToProps, {
  saveRecruitmentRequest,
})(NewRecruitmentRequestDialog);
